import { Injectable } from '@angular/core';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';


@Injectable({ providedIn: 'root' })
export class IconService {


    constructor(private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer) {

    }
    connectIcons() {
        this.matIconRegistry.addSvgIcon(
            'adminAddPhoto',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-add-photo.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminDate',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-date.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminWarnCircle',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-warn-circle.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminAttach',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-attach.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminCaution',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-caution.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminDelete',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-delete.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminDeleteGray',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/delete.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'ban',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/ban.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminDisabled',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-disabled.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminOnHold',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-on-hold.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'infoBlue',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/info-3.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'info',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/info.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'check',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/check-circle-blue.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminPassword',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-password.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminEdit',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-edit.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'icon-custom',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-shift-custom.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'icon-dayshift',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-shift-day.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'icon-nightshift',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-shift-night.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'icon-noonshift',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-shift-noon.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminCalendar',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-calendar.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'export',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/export.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'exportBlue',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/export-blue.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'exportGray',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/export-gray.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'documentText',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/document-text.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'exportUser',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/export-user.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'exportCalendar',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/export-calendar.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'exportOffice',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/export-office.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminRedit',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-redit.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminClock',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-clock.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'rectangle',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/rectangle.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminXCircle',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-x-circle.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminGreyX',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-grey-x.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'rateHistory',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/rate-history.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'podIllustration',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/pod-illustration.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'adminTrusted',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/admin-trusted.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'calendarSearch',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/calendar-search.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'csvUpload',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/csv-upload.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'addDocument',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/add-document.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'password',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/password.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'password-eye',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/password-eye.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'percentReceipt',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/percent-receipt.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'close',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/close.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'boostedRate',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/boosted-rate.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'wallet',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/wallet.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'creditCard',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/credit-card.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'checkCircleGreen',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/check-circle-green.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'plus',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/plus.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'plusCircle',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/plus-circle.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'refresh',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/refresh.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'info-circle',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/info-circle.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'doc-search',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/document-search.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'check-blue',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/check-blue.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'check-green',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/check-green.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'arrow-round-right',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/arrow-round-right.svg'),
        );
    }
}
